'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAvatarProps;
function getAvatarProps(_ref) {
  var fills = _ref.fills;

  /**
   * @param {boolean} isSolid
   * @param {string} color — automatic or actual color
   * @param {number} hashValue
   * @return {Object} { color, backgroundColor }
   */
  var getAvatarProps = function getAvatarProps(_ref2) {
    var isSolid = _ref2.isSolid,
        color = _ref2.color,
        hashValue = _ref2.hashValue;

    var appearances = fills[isSolid ? 'solid' : 'subtle'];

    if (color === 'automatic') {
      var keys = Object.keys(appearances);
      var key = keys[hashValue % keys.length];
      return appearances[key];
    }

    return appearances[color];
  };

  return getAvatarProps;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL2Jhc2UvZ2V0QXZhdGFyUHJvcHMuanMiXSwibmFtZXMiOlsiZ2V0QXZhdGFyUHJvcHMiLCJmaWxscyIsImlzU29saWQiLCJjb2xvciIsImhhc2hWYWx1ZSIsImFwcGVhcmFuY2VzIiwia2V5cyIsIk9iamVjdCIsImtleSIsImxlbmd0aCJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBQXdCQSxjO0FBQVQsU0FBU0EsY0FBVCxPQUFtQztBQUFBLE1BQVRDLEtBQVMsUUFBVEEsS0FBUzs7QUFDaEQ7Ozs7OztBQU1BLE1BQU1ELGlCQUFpQixTQUFqQkEsY0FBaUIsUUFBbUM7QUFBQSxRQUFoQ0UsT0FBZ0MsU0FBaENBLE9BQWdDO0FBQUEsUUFBdkJDLEtBQXVCLFNBQXZCQSxLQUF1QjtBQUFBLFFBQWhCQyxTQUFnQixTQUFoQkEsU0FBZ0I7O0FBQ3hELFFBQU1DLGNBQWNKLE1BQU1DLFVBQVUsT0FBVixHQUFvQixRQUExQixDQUFwQjs7QUFFQSxRQUFJQyxVQUFVLFdBQWQsRUFBMkI7QUFDekIsVUFBTUcsT0FBT0MsT0FBT0QsSUFBUCxDQUFZRCxXQUFaLENBQWI7QUFDQSxVQUFNRyxNQUFNRixLQUFLRixZQUFZRSxLQUFLRyxNQUF0QixDQUFaO0FBQ0EsYUFBT0osWUFBWUcsR0FBWixDQUFQO0FBQ0Q7O0FBRUQsV0FBT0gsWUFBWUYsS0FBWixDQUFQO0FBQ0QsR0FWRDs7QUFZQSxTQUFPSCxjQUFQO0FBQ0QiLCJmaWxlIjoiZ2V0QXZhdGFyUHJvcHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRBdmF0YXJQcm9wcyh7IGZpbGxzIH0pIHtcbiAgLyoqXG4gICAqIEBwYXJhbSB7Ym9vbGVhbn0gaXNTb2xpZFxuICAgKiBAcGFyYW0ge3N0cmluZ30gY29sb3Ig4oCUIGF1dG9tYXRpYyBvciBhY3R1YWwgY29sb3JcbiAgICogQHBhcmFtIHtudW1iZXJ9IGhhc2hWYWx1ZVxuICAgKiBAcmV0dXJuIHtPYmplY3R9IHsgY29sb3IsIGJhY2tncm91bmRDb2xvciB9XG4gICAqL1xuICBjb25zdCBnZXRBdmF0YXJQcm9wcyA9ICh7IGlzU29saWQsIGNvbG9yLCBoYXNoVmFsdWUgfSkgPT4ge1xuICAgIGNvbnN0IGFwcGVhcmFuY2VzID0gZmlsbHNbaXNTb2xpZCA/ICdzb2xpZCcgOiAnc3VidGxlJ11cblxuICAgIGlmIChjb2xvciA9PT0gJ2F1dG9tYXRpYycpIHtcbiAgICAgIGNvbnN0IGtleXMgPSBPYmplY3Qua2V5cyhhcHBlYXJhbmNlcylcbiAgICAgIGNvbnN0IGtleSA9IGtleXNbaGFzaFZhbHVlICUga2V5cy5sZW5ndGhdXG4gICAgICByZXR1cm4gYXBwZWFyYW5jZXNba2V5XVxuICAgIH1cblxuICAgIHJldHVybiBhcHBlYXJhbmNlc1tjb2xvcl1cbiAgfVxuXG4gIHJldHVybiBnZXRBdmF0YXJQcm9wc1xufVxuIl19